<script>
	import { firstBottomBoxVisible } from '../js/model/stores';

	let animate = '';

	firstBottomBoxVisible.subscribe(value => {
		console.log('foo', value, typeof value);
		if(!value) {
			return;
		}
		animate = 'animate';
	})
</script>
<style>
	:global(.be_logo) {
		position: absolute;
		top: calc(-6em - (var(--base-size) * 6.5));
		right: 2vw;
		width: calc(var(--base-size) * 6.5);
		height: calc(var(--base-size) * 6.5);
		z-index: -1;
	}

	:global(.be_logo.animate) {
		animation: logo 2s linear;
			top: calc(var(--font-h2-size) - var(--base-size));
	}

	@keyframes logo {
		0% {
			top: calc(-6em - (var(--base-size) * 6.5));
		}
		20% {
			top: calc(var(--font-h2-size) - var(--base-size) + 1.5vh);
		}
		40% {
			top: calc(var(--font-h2-size) - var(--base-size) - 2vh);
		}
		60% {
			top: calc(var(--font-h2-size) - var(--base-size) + 1vh);
		}
		100% {
			top: calc(var(--font-h2-size) - var(--base-size));
		}
	}
</style>
<svg class="be_logo" class:animate width="136" height="136" viewBox="0 0 136 136" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M81.9605 14.3079C52.5023 6.41465 22.1992 23.9016 14.3004 53.3801C6.39894 82.8688 23.9015 113.154 53.3596 121.048C82.8382 128.946 113.139 111.47 121.04 81.9809C128.939 52.5024 111.439 22.2067 81.9605 14.3079ZM60.9275 39.1176L76.6202 34.1155L87.824 46.1932L84.9995 56.7343L80.2267 59.4295L77.4487 69.797L58.3479 64.679L61.0219 54.6996L58.1467 49.4954L60.9275 39.1176ZM71.5369 91.86L73.8387 83.2697C73.8387 83.2697 73.1454 76.9095 65.7604 74.9307C58.3755 72.9519 54.9304 77.842 54.9304 77.842L52.5356 86.7795L28.9916 80.4709L44.9616 50.8999L54.2417 45.4384L59.5825 54.719C59.5825 54.719 56.9414 64.5758 56.8401 64.9537C56.7389 65.3317 56.7325 65.5599 57.0083 65.6337C57.284 65.7076 77.2633 71.0611 77.631 71.1596C77.9987 71.2581 78.3932 71.1339 78.5082 70.7049C78.6231 70.2759 81.2369 60.5213 81.2369 60.5213L90.4766 55.1694L95.8828 64.5332L94.7745 98.0865L71.5369 91.86Z" fill="#154510"/>
</svg>
